import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { formatNullableString, logError, toNullableLocaleDateTimeString } from '../utilities';
import ShipmentUpdateCreateForm from './ShipmentUpdateCreateForm';
import { toast } from 'react-toastify';
import { ShipmentStatusModel } from '../apiModels/shipmentStatusModel';
import { ShipmentStatuses } from '../appConstants';
import { createShipmentUpdate, getStatusOptions } from '../api/shipmentUpdateApi';
import { Value } from 'react-datetime-picker/dist/cjs/shared/types';
import LoadingIcon from './LoadingIcon';
import { requestProofOfDelivery } from '../api/proofOfDeliveryApi';

export default function ProofOfDeliveryRequestModal(props: { 
        show: boolean, 
        setShow: (show: boolean) => void, 
        shipmentTrackingNumber: string
}) {
    const notifyUserOfError = (err: string) => toast(err, { type: 'error' });
    const notifyUserOfSuccess = (msg: string) => toast(msg, { type: 'success' });

    const [email, setEmail] = useState<string>();
    const [isSaving, setIsSaving] = useState(false);

    const saveRequest = async () => {
        setIsSaving(true);

        if (props.shipmentTrackingNumber === undefined) {
            notifyUserOfError('Invalid shipment.');
            setIsSaving(false);
            return;
        }

        if (email === undefined) {
            notifyUserOfError('You must provide an email address.');
            setIsSaving(false);
            return;
        }

        try {
            const s = await requestProofOfDelivery({
                shipmentTrackingNumber: props.shipmentTrackingNumber,
                email: email
            });

            setIsSaving(false);
            notifyUserOfSuccess('Request for proof of delivery submitted successfully.');
            
            props.setShow(false);
        }
        catch (error: any) {
            if (error instanceof Error) {
                notifyUserOfError(error.message);
            }

            logError(error);
            setIsSaving(false);
        }
    };

    return (    
        <>
            <Modal show={props.show} onHide={() => props.setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Request Proof Of Delivery</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="alert alert-info">
                        <p>
                            Enter your email address to receive a proof of delivery for this shipment.
                        </p>
                    </div>

                    <label htmlFor="email" className="form-label">Email</label>
                    <input className="form-control" name="email" type="email" placeholder="jdoe@mail.com" required={true} maxLength={500} value={email} onChange={(e) => setEmail(e.target.value)} />
                </Modal.Body>
                <Modal.Footer>
                    <div className="row">
                        <div className="col-12 text-end">
                            <button
                                className='btn btn-default mt-3'
                                onClick={() => props.setShow(false)}>
                                Close
                            </button>
                            <button className="btn btn-primary mt-3" disabled={isSaving} onClick={saveRequest}>
                                <i className="bi bi-save"></i> Save
                            </button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export const ButtonLoadingSpinner = () => {
    return (
        <div className="spinner-border spinner-border-sm text-default" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    );
};